
import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { Link } from "react-router-dom";
import moment from 'moment';

import profileImg from '../../assets/images/SATI/profile-current.png';

const ProfileHero = ({ user }) => {
  let {
    nombre: name,
    fechaNacimiento: birthdate,
    email
  } = user;

  const age = moment().diff(moment(birthdate).format('YYYY-MM-DD'), 'years');

  return (
    <Card>
      <CardBody>
        <Row>
          <Col xs={3} className="d-flex align-items-center">
            <img src={profileImg} alt="" style={{ width: '100%' }}/>
          </Col>
          <Col xs={9}>
            <h3 className="text-primary"><small>{name}</small></h3>
            <p>{age} años</p>
            <p>{email}</p>
            <Link to='/logout'>
              <i className="mdi mdi-logout font-size-17 align-middle mr-1"></i>
              <span>Cerrar sesión</span>
            </Link>
          </Col>
        </Row>
      </CardBody>
    </Card>
  )
}

export default ProfileHero;
